<template>
	<div id="calc" class="calculator wrapper container-fluid" @click.stop.prevent="handleClick">

		<p class="txt--xl mb--2 mb-2">
			Predicts likelihood of streptococcal sore throat, and suggests whether use of antibiotics is appropriate.
		</p>

		<div class="tabs mb--2">
			<nav class="tabs__nav">
				<button v-for="(tab) in tabs" v-bind:key="tab.title" role="button" class="tabs__nav-item txt--strong" :class="{ 'tabs__nav-item--active bg--primary': tab.display }" v-on:click="selectTab(tab)">
					<span v-html="tab.title"></span>
					<i v-if="!tab.display" aria-hidden="true" class="fa fa-chevron-down ml-1 ml--1 show--md"></i>
					<i v-if="tab.display" aria-hidden="true" class="fa fa-chevron-up ml-1 ml--1 show--md"></i>	
				</button>
			</nav>
			<div class="tabs__content" id="tabcontent">
				<div v-for="(tab) in tabs" v-bind:key="tab.content">
					<div v-if="tab.display" class="bdr--light-gray p--1 wysiwyg" role="tabpanel" :aria-labelledby="tab.title" v-html="tab.content"></div>
				</div>
			</div>
		</div>

		<div class="questions__intro-text">
			<div class="row">
				<div class="col-xs-12">
					<p>Click on the answer to each question below, then click on Calculate.</p>
				</div>
			</div>
		</div>

		<div class="row" v-for="q in questions" :key="q.id">
			<div class="col-12 col-xs-12 mb-1 mb--1">
				<div class="row" v-if="q.header != ''">
					<div class="col-12 col-xs-12"><h2>{{q.header}}</h2></div>
				</div>
				<div class="row">
					<div class="col-12 col-xs-12 col-sm-6">
						<h3 class="txt--xl mb-1 mb--1">{{q.title}}</h3>
						<p v-html="q.info"></p>
					</div>
					<div class="col-12 col-xs-12 col-sm-6">
						<div class="list-group">
							<div v-for="o in q.options" :key="o.id">
								<button @click="optionclicked(q.id,o.id)"
										@keydown.enter="optionclicked(event, q.id,o.id)"
										type="button"
										v-bind:class="{'list-group-item list-group-item-action d-flex justify-content-between align-items-center active':(o.selected), 'list-group-item list-group-item-action d-flex justify-content-between align-items-center':(!o.selected)}">
									{{o.text}}
									<span class="badge badge-success badge-pill">{{o.value_label}}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<hr class="mb-2 mb--2">
			</div>
		</div>
		<div id="error" class="row">
			<div class="col-12 col-xs-12">
				<div class="alert alert-info alert--info alert-informative mb-3 mb--3" role="alert" v-if="errormessage.length > 0" v-html="errormessage"></div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-xs-12">
				<div class="calculator__result bg-secondary bg--secondary p--2 p-2 mb--2 mb-2">
					<div id="calculator-copy" class="color--white text-white mb-1 mb--1" v-if="displayresult">
						<div id="result-response" v-if="isvalid"></div>					
						<p v-if="result.text.length > 0 && errormessage.length == 0" class="h3 txt--xl"><strong>Recommendation:</strong> {{result.text}}</p>	
						<h3 v-if="errormessage.length == 0"  class="h4 txt--lg"><strong>Total FeverPAIN Score</strong> : {{result.score}}</h3>
						<h3 v-if="errormessage.length > 0"  class="h4 txt--lg"><strong>Total FeverPAIN Score</strong> : N/A</h3>
						<p v-if="result.calctext.length > 0 && errormessage.length == 0" v-html="result.subtext"></p>
						<p v-if="result.text.length > 0" v-html="result.calctext"></p>
					</div>
					<div class="control-holder">
						<button class="btn mr-1 mr--1" @click="calculateclicked" type="button" v-if="!displayresult">Calculate</button>
						<button class="btn mr-1 mr--1" type="button" @click="reset" v-if="displayresult">Reset</button>
            <button class="btn mr-1 mr--1" id="copyButton" type="button" @click="copyToClipboard" v-if="displayresult">Copy Result</button>
						<button class="btn mr-1 mr--1 hide--quris" type="button" @click="displayForm" v-if="displayresult">Email PDF</button>
					</div>
				</div>
				<div class="bg--offwhite bg-offwhite p-2 p--2" v-if="displayresult && showform">					
						<p class="color--black">For security reasons, this form is only available within the NHS network. You can use it to email to an NHS email a PDF with the decision support result for this patient and then save it to the patient record.</p>
						<div class="color--black alert alert-danger alert--error mb-1 mb--1" role="alert" v-if="emailmessage.length > 0" v-html="emailmessage"></div>
						<div class="form__group mb--2">
							<label for="emailaddresses" class="form__label mb--1 txt--strong">Email addresses:</label>
							<input v-model="emailaddresses" type="text" class="form__input" name="emailaddresses" id="emailaddresses" placeholder="Enter email address(es) to receive this decision support output. NHS emails only">
						</div>
						<div class="form__group mb--2">
							<label for="patientname" class="form__label mb--1 txt--strong">Patient's Full Name:</label>
							<input v-model="patientname" type="text" class="form__input" name="patientname" id="patientname" placeholder="Enter patient’s full name">
						</div>
						<div class="form__group mb--2">
							<label for="patientchinumber" class="form__label mb--1 txt--strong">Patient CHI Number:</label>
							<input v-model="patientchinumber" type="text" class="form__input" name="patientchinumber" id="patientchinumber" placeholder="Enter patient’s CHI number">
						</div>
						<button class="btn mr-1 mr--1" type="button" @click="sendToPDF">Send</button>
					</div>
					<div class="alert alert-success alert--success mb-3 mb--3 " role="alert" v-if="displayresult && !showform && emailmessage.length > 0 && emailaddresses.length > 0 && patientname.length > 0 && patientchinumber.length > 0" v-html="emailmessage"></div>
			</div>
		</div>
		<Content />
	</div>
</template>

<script>
import Content from '@/components/Content';
import "isomorphic-fetch";

export default {
	name: "Calculator",
	components: {
    Content
  },
  data() {
    return {
      emailaddresses: "",
      patientname: "",
      patientchinumber: "",
      questions: [
        {
          id: "q1",
					title: "Fever in past 24 hours",
					header: "History",
          required: true,
          info: "",
          options: [
            {
              id: "o1",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o2",
              text: "Yes",
              value_label: "+1",
              value: 1,
              selected: false
            }
          ]
        },
        {
          id: "q2",
          title: "Absence of cough or coryza",
					header: "",
          required: true,
          info: "",
          options: [
            {
              id: "o3",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o4",
              text: "Yes",
              value_label: "+1",
              value: 1,
              selected: false
            }
          ]
        },
        {
          id: "q3",
          title: "Symptom onset 3 days or less",
					header: "",
          required: true,
          info: "",
          options: [
            {
              id: "o3",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o4",
              text: "Yes",
              value_label: "+1",
              value: 1,
              selected: false
            }
          ]
        },
        {
          id: "q4",
          title: "Purulent tonsils",
					header: "Physical exam findings",
          required: true,
          info: "",
          options: [
            {
              id: "o3",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o4",
              text: "Yes",
              value_label: "+1",
              value: 1,
              selected: false
            }
          ]
        },
        {
          id: "q5",
          title: "Severe inflammation of tonsils",
					header: "",
          required: true,
          info: "",
          options: [
            {
              id: "o3",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o4",
              text: "Yes",
              value_label: "+1",
              value: 1,
              selected: false
            }
          ]
        }
      ],
      result: {
        score: 0,
        calctext: "",
        text: "",
        subtext: ""
      },
      displayresult: false,
      showform: false,
      errormessage: "",
      emailmessage: "",
      isvalid: false,
      answered_count: 0,
			answer_acutechange: false,
			tabs: [
        {
					title: "When to use",
					display: false,
          accordion: false,
					content: `
						<p>Use for patients 3 years or older in primary care settings with recent onset (3 days or less) acute pharyngitis. Should not be used in children <3 years old, as they are more likely to have viral infections and/or atypical presentations of streptococcal infection.</p>
						<p>While further validation is  required, FeverPAIN may have better utility than Centor at lower levels to detect patients who could forgo antibiotic treatment (<a href="https://www.ncbi.nlm.nih.gov/books/NBK261552/" target="_blank">Little 2014</a>).</p>
						<p>For patients that have worsening symptoms beyond 3 days, the clinician must consider the possibility of a more serious or invasive infection.</p>`,
        },
        {
          title: "Evidence",
					display: false,
          accordion: false,
					content: `
						<p>The FeverPAIN Score was derived from <a href="http://www.ncbi.nlm.nih.gov/pmc/articles/PMC3805475/#!po=87.5000" target="_blank">a 2013 study of 1,760 patients</a> aged 3 years and up. The objective of the authors was to design a clinical tool that was able to predict streptococcal infection,  to reduce the need for rapid antigen detection tests and potentially unnecessary antibiotics.  The study compared three groups: a control group in which patients received a delayed antibiotic prescription, a clinical score group, and a rapid antigen detection test group. The authors concluded that the use of a rapid antigen test according to a clinical score provided no clear advantage over a clinical score alone.  They also found that use of a clinical score improved symptoms and reduced antibiotic usage.</p>
						<h4 class="txt--lg">References</h4>
						<p>Little P, Hobbs FD, Moore M, et al. Clinical score and rapid antigen detection test to guide antibiotic use for sore throats: randomised controlled trial of PRISM (primary care streptococcal management)]. <em>BMJ</em>. 2013;347:f5806. Published 2013 Oct 10. <a href="https://www.bmj.com/content/347/bmj.f5806" target="_blank">doi:10.1136/bmj.f5806</a></p>
						<p>Little P, Hobbs FD, Moore M, et al. PRImary care Streptococcal Management (PRISM) study: in vitro study, diagnostic cohorts and a pragmatic adaptive randomised controlled trial with nested qualitative study and cost-effectiveness study [published correction appears in <em>Health Technol Assess</em>. 2018 Oct;18(6):103-104]. Health Technol Assess. 2014;18(6):vii-101. <a href="https://pubmed.ncbi.nlm.nih.gov/24467988/" target="_blank">doi:10.3310/hta18060</a></p>
					`,
        },
        {
          title: "Calculation<span class='show--md'> & interpretation</span>",
					display: false,
          accordion: false,
					content: `
						<h4 class="txt--lg">Calculation</h4>
						<p>To calculate the total FeverPAIN score, a score of  0 or +1 is assigned to Yes/No values for each criterion, as shown in the table below. The total FeverPAIN score is the result of adding the individual scores for each  criterion.</p>
						<table class="tbl table">
							<tr>
								<th width="45%">Name</th>
								<th width="35%">Input value</th>
								<th width="20%" align="right">Score</th>
							</tr>
							<tr>
								<td>Fever in past 24 hours</td>
								<td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td>Absence of cough or coryza</td>
								<td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td>Symptom onset <=3 days</td>
								<td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td>Purulent tonsils</td>
								<td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td>Severe inflammation of tonsils</td>
								<td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>
						</table>
						<h4 class="txt--xl">Interpreting FeverPAIN scores</h4>
						<ul>
							<li>A score of 0-1 is associated with 13-18% isolation of streptococcus (close to background carriage rates).   No antibiotics recommended.</li>
							<li>A score of 2 is associated with 30-35% isolation of streptococcus. Delayed antibiotic may be appropriate.</li>
							<li>A score of 3 is associated with 39-48% isolation of streptococcus. Delayed antibiotic may be appropriate.</li>
							<li>A score of 4 or more is associated with 62-65% isolation of streptococcus. Consider antibiotics if symptoms are severe or a short delayed prescribing strategy may be appropriate (48 hours).</li>
						</ul>
					`,
        },{
          title: "Practice<span class='show--md'> considerations</span>",
					display: false,
          accordion: false,
					content: `
						<p>In applying the FeverPAIN score in practice, clinicians should be aware that:</p>
						<ul>
						<li>The <a href="https://www.nice.org.uk/guidance/dg38/chapter/3-Evidence" target="_blank">NICE Diagnostic guidance</a> on rapid tests for Group A streptococcal infections in people with sore throat was unable to identify any studies reporting the accuracy of the FeverPAIN scoring tool, so could not report on its sensitivity and specificity.</li>
						<li>The FeverPAIN criteria were developed in a UK primary care setting in 2013 (in contrast to Centor, which was developed for a US emergency department population).</li>
						<li>FeverPAIN has not been assessed in children under 3 years.</li>
						<li>External validation has not been carried out, but FeverPAIN has been tested in an RCT setting.</li>
						<li>A FeverPAIN score of 4 or 5 is thought to be associated with a 62-65% probability of having a bacterial infection, which is slightly higher than the 32-56% probability associated with a Centor score of 3 or 4. Using FeverPAIN in preference to Centor may therefore increase the use of antibiotic prescribing.</li>
						<li>The <a target="_blank" href="https://www.nice.org.uk/guidance/NG84/chapter/Summary-of-the-evidence#identifying-people-more-likely-to-benefit-from-antibiotics">NICE guideline NG84 overview</a> of identifying people most likely to benefit from antibiotics includes a fuller comparison of Centor and FeverPAIN scoring systems.</li>
					</ul>
					`,
        }
      ]
    };
  },
  methods: {	
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) 
        {
          window.open(url,target);  
        }
        else{
          if(target == "_blank") {
            let data = {title:'',nodeid: dataId, href:url, target: target};
            window.Native('dataCallback', data);
          } 
        }	
      }
    },
		selectTab(selectedTab) {
			this.tabs.forEach(tab => {
				if(tab.display) {
					tab.display = false;
				} else {
					tab.display = (tab.title == selectedTab.title);
				}
			});
		},
    reset() {
      this.emailaddresses = "";
      this.patientname = "";
      this.patientchinumber = "";
      this.result.score = 0;
      this.result.calctext = "";
      this.result.text = "";
      this.displayresult= false;
      this.showform = false;
      this.errormessage= "";
      this.emailmessage = "";
      this.isvalid= false;
      this.answered_count= 0;
      this.answer_acutechange= false;
      this.questions.forEach(q => {
        q.options.forEach(o => {
            o.selected = false;
          });
      });
    },
    calculateclicked() {
			this.emailmessage	= "";
      this.emailaddresses = "";
      this.patientname = "";
      this.patientchinumber = "";
      this.showform = false;
			this.displayresult = true;
      if (this.answered_count < this.questions.length) {
        this.errormessage =	"<h2 class='txt--lg'>One or more inputs missing. </h2>";
				this.errormessage += "<p>Total FeverPAIN score cannot be calculated as one or more inputs are missing. </p>";
				this.errormessage += "<p>Required inputs are: Fever in past 24 hours, Absence of cough or coryza, Symptom onset <= 3 days, Purulent tonsils, Severe tonsil inflammation. </p>";
				this.errormessage += "<p>If any 4 of the 5 FeverPAIN criteria are met, consider antibiotics as there is a 62-65% probability of isolation of streptococcus</p>";
				setTimeout(()=> {
					document.getElementById("error").scrollIntoView(true)},100);
      } else {
        this.errormessage = "";
      }
		},
		displayForm(){		
      this.showform = !this.showform;
		},
    copyToClipboard() {
      var range;
      var finalText = "";
      if (document.selection) { // IE
        range = document.body.createTextRange();
        range.moveToElementText(document.getElementById('calculator-copy'));
        range.select();
        finalText = this.getDateToday() + "\n\nFeverPAIN Score for Strep Pharyngitis\n\n" + range + "\nEnter action taken as a result of this alert";
        document.selection.empty();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(document.getElementById('calculator-copy'));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        finalText = this.getDateToday() + "\n\nFeverPAIN Score for Strep Pharyngitis\n\n" + window.getSelection().toString() + "Enter action taken as a result of this alert";
        window.getSelection().removeAllRanges();
      }
      var dummy = document.createElement("textarea");
      // Add it to the document
      document.body.appendChild(dummy);

      // Set its ID
      dummy.setAttribute("id", "dummy_id");

      // Output the array into it
      document.getElementById("dummy_id").value = finalText;

      // Select it
      dummy.select();

      // Copy its contents
      document.execCommand("copy");

      // Remove it as its not needed anymore
      document.body.removeChild(dummy);

      var clicked = false;
      var copyButton = document.getElementById('copyButton');
      if (!clicked) {
            var last = copyButton.innerHTML;
            copyButton.innerHTML = 'Copied!';
            clicked = true;
            setTimeout(function () {
                copyButton.innerHTML = last;
                clicked = false;
            }.bind(copyButton), 5000);
        }
    },
    getDateToday() {
      var date = "";
      var today = new Date();
      date = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + " " + (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) + ":" + (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());
      return date;
    },
    sendToPDF() {
				if (this.patientchinumber == "" || this.patientname == "" || this.patientchinumber == ""){
						this.emailmessage = "All fields are required."
				}
        else {
            var formToPost = {
                EmailAddresses: this.emailaddresses,
                PatientName: this.patientname,
                PatientChiNumber: this.patientchinumber,
                Questions: this.questions,
                Result: this.result,
                DisplayWarning: this.answered_count < this.questions.length,
            };

            var model = JSON.stringify(formToPost);

            fetch("/SoreThroat/GetFeverPainPDF", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: model
            })
                .then(response => response.text())
                .then(data => {
                    if (data.startsWith("Email Error: ")) {
                        this.emailmessage = data.replace("Email Error: ", "");
                        this.showform = true;
                    } else {
                        this.emailmessage = data;
                        this.showform = false;
                    }
                })
                .catch((error) => {
                    console.log('EMAIL ERROR', error);
                });
        }
    },
		anchorLink(i) {
			var element = document.getElementById(i);
			element.scrollIntoView();
		},
		
    closedclicked() {
      this.displayresult = false;
    },
    optionclicked(qid, oid) {
      this.displayresult = false;
      let _score = 0;
      this.questions.forEach(q => {
        if (q.id === qid) {
          q.options.forEach(o => {
            if (o.id === oid) {
              if(o.selected)
              {
                o.selected = false;
              }
              else
              {
                o.selected = true;
              }
              
            } else {
              o.selected = false;
            }
          });
        }
      });
      let _cnt = 0;
      let _required_cnt = 0;
      let _required_answered_cnt = 0;
      this.answer_acutechange = false;
      this.questions.forEach(q => {
        if (q.required) {
          _required_cnt++;
        }
      });
      this.questions.forEach(q => {
        q.options.forEach(o => {
          if (o.selected) {
            _score += o.value;
            _cnt++;
          }
          if (o.selected && q.required) {
            _required_answered_cnt++;
          }
          // if (q.id === "q4") {
          //   if (o.selected) {
          //     this.answer_acutechange = true;
          //   }
          // }
        });
      });

      this.answered_count = _cnt;
      this.isvalid = _required_answered_cnt === _required_cnt ;
      if (this.isvalid) {
        this.errormessage = "";
      }
      this.result.score = _score;

      if (_score <= 1) {
				this.result.text = "No antibiotics recommended";
				this.result.subtext = "13-18% probability of isolation of streptococcus (close to background population rates).<br><br>Clinicians should refer to local guidance when appropriate."
      }
      if (_score == 2) {
				this.result.text = "Delayed antibiotic may be appropriate";
				this.result.subtext = "30-35% probability of isolation of streptococcus.<br><br>Clinicians should refer to local guidance when appropriate."
			}
			if (_score == 3) {
				this.result.text = "Delayed antibiotic may be appropriate";
				this.result.subtext = "39-48% probability of isolation of streptococcus.<br><br>Clinicians should refer to local guidance when appropriate."
			}
			if (_score == 4) {
				this.result.text = "Consider antibiotics if symptoms are severe or short delayed prescribing strategy may be appropriate (48 hours)";
				this.result.subtext = "62-65% probability of isolation of streptococcus.<br><br>Clinicians should refer to local guidance when appropriate."
			}

      

      let _calctext = "";
      let _idx2 = 0;
      //let _len = this.questions.length;
      this.questions.forEach(q => {
        //_calctext = _calctext + q.title+": ";

        q.options.forEach(o => {
          if (o.selected) {
            if (_idx2 === 0) {
							_calctext = _calctext + "<strong>" + q.title + "</strong><br><span class='badge badge-success badge-pill'>"+ o.value_label + "</span>&nbsp;"+ o.text +"<br><br>";
            } else {
							_calctext = _calctext + "<strong>" + q.title + "</strong><br><span class='badge badge-success badge-pill'>"+ o.value_label + "</span>&nbsp;"+ o.text +"<br><br>";
            } 
          }
				});

        _idx2++;
      });
      
      this.result.calctext = _calctext;
    }
  }
};
</script>

